import React from 'react'
import Tab from '@mui/material/Tab';
import { Link as RouterLink } from 'react-router-dom';

const LinkTab = (props) => {
    return (
        <Tab
            component={RouterLink}
           
            {...props}
        />
    )
}

export default LinkTab